import { CurrentUser } from '../modals/CurrentUser';
import { ForgotPasswordRequest } from '../modals/ForgotPasswordRequest';
import { CommonMethodService } from './CommonMethodService';

const apiAdBaseUrl = "https://adonis.flowautobody.com/api/";
// const apiAdBaseUrl = 'http://127.0.0.1:3333/api/';
const apiAdBase = "https://adonis.flowautobody.com/";
// const apiAdBase = 'http://127.0.0.1:3333/';
// const apiBaseUrl = "https://api.flowautobody.com" //aws
const apiBaseUrl = 'https://flowautobody.azurewebsites.net'; //azure

const allowedEmails = [
  'isko20951@gmail.com',
  'tahir60652@gmail.com',
  'tb.crm12@gmail.com',
  'renatofrias@outlook.com'
];

export class APIService {
  private currentUser: CurrentUser;
  private commonMethodService = new CommonMethodService();

  constructor() {
    this.currentUser =
      this.commonMethodService.getDataFromStorage('currentUser');
  }

  sendRequest(url: string, method: string, data: any) {
    let requestOptions: any = {
      method: method,
      headers: { 'Content-Type': 'application/json' }
    };
    if (data) {
      requestOptions['body'] = JSON.stringify(data);
    }

    return fetch(apiBaseUrl + url, requestOptions);
  }

  private sendRequestApi(
    url: string,
    method: string,
    data?: any,
    token?: string
  ) {
    let requestOptions: any = {
      method: method,
      headers: { 'Content-Type': 'application/json' }
    };
    if (data) {
      requestOptions['body'] = JSON.stringify(data);
    }
    if (this.currentUser?.auth || token) {
      requestOptions['headers'] = {
        ...requestOptions['headers'],
        Authorization: `Bearer ${token ? token : this.currentUser.auth.token}`
      };
    }

    return fetch(apiAdBaseUrl + url, requestOptions);
  }

  sendRequestAdonisApi(url: string, method: string, data: any) {
    let requestOptions: any = {
      method: method,
      headers: { 'Content-Type': 'application/json' }
    };
    if (data) {
      requestOptions['body'] = JSON.stringify(data);
    }

    return fetch(apiAdBase + url, requestOptions);
  }

  async forgotPassword(forgotPasswordPayload: ForgotPasswordRequest) {
    return await this.sendRequestApi(
      'forgot-password',
      'POST',
      forgotPasswordPayload
    );
  }

  async getPreInspection(estimateNumber: string, token?: string) {
    return await this.sendRequestApi(
      `pre-inspection/${estimateNumber}`,
      'GET',
      null,
      token
    );
  }

  async getFile(name: string, path: string) {
    return await this.sendRequestApi(`file/${path}/${name}`, 'GET', null);
  }

  async sendJSONFile(json: object, id: string) {
    return await this.sendRequestApi(`pre-inspection/${id}/json-file`, 'PUT', {
      json,
      path: 'customer_signature'
    });
  }

  async updatePreInspection(data: any, id: string) {
    return await this.sendRequestApi(`pre-inspection/${id}`, 'PUT', data);
  }

  async getBookingDays() {
    return await this.sendRequestApi('booking-day', 'GET', null);
  }

  async bookSlot(slot: any) {
    return await this.sendRequestApi('booking', 'POST', slot);
  }
  async bookSlotUpdate(id: string, slot: any) {
    return await this.sendRequestApi('booking/' + id, 'PUT', slot);
  }

  async getBookingForId(id: string) {
    return await this.sendRequestApi(
      'booking?jobExternalId=' + id,
      'GET',
      null
    );
  }

  async getCustomerData(customer: {
    externalId: string;
    name: string;
    email: string;
    typeOfRequest?: string;
  }) {
    return await this.sendRequestApi('customer/register', 'POST', customer);
  }

  async login(email: string, password: string, estimateNumber: string) {
    return await this.sendRequestApi('login', 'POST', {
      email,
      password,
      estimateNumber
    });
  }

  async loginMagicLink(userId: string, token: string) {
    return await this.sendRequestApi(
      `login-magic-link/${userId}/${token}`,
      'POST'
    );
  }

  async reSendEmail(userId: number) {
    return await this.sendRequestApi('active', 'POST', {
      userId
    });
  }

  private sendRequestApiNotification(url: string, method: string, data: any) {
    let requestOptions: any = {
      method: method,
      headers: { 'Content-Type': 'text/html' }
    };
    if (data) {
      requestOptions['body'] = data;
    }
    if (this.currentUser?.auth) {
      requestOptions['headers'] = {
        ...requestOptions['headers'],
        Authorization: `Bearer ${this.currentUser.auth.token}`
      };
    }
    return fetch(apiAdBaseUrl + url, requestOptions);
  }

  async sendTeamsNotification(message: string, email: string) {
    if (!allowedEmails.includes(email)) {
      return await this.sendRequestApiNotification(
        'notifications',
        'POST',
        message
      );
    }
  }

  async sendCustomerChatNotification(message: string, email: string) {
    if (!allowedEmails.includes(email)) {
      return await this.sendRequestApiNotification(
        'customerChat',
        'POST',
        message
      );
    }
  }

  async sendResetPassword(data: any) {
    return await this.sendRequestAdonisApi(
      'reset-password-with-email/' + data.email,
      'POST',
      data
    );
  }

  async changePassword(data: any) {
    return await this.sendRequestAdonisApi(
      'change-password/' + this.currentUser.user.id,
      'POST',
      data
    );
  }

  async getBookingAllowance() {
    return await this.sendRequestApi('booking-allowance', 'GET', null);
  }
}

export default APIService;
